import { CAMPAIGN_RANKINGS, CandidateServicePath } from "utils/constants";
import permissions from "app/permissions";
import ShowRankingResults from "./Show";

export const resources = {
  name: `${CandidateServicePath}${CAMPAIGN_RANKINGS}`,
  show: <ShowRankingResults />,
  permission: permissions.canPreviewCampaignRankings,
};
